import { cloneDeep } from '@apollo/client/utilities';
import { EntityInput, forCreate, forDelete, forUpdate } from '../common/entity';
import { ExportType } from '../export/export';
import { TaskExportConfiguration } from './taskExportConfiguration';

export class TaskExportConfigurationInput
  extends TaskExportConfiguration
  implements EntityInput<TaskExportConfiguration>
{
  forCreate(): CreateTaskExportConfigurationInput {
    return CreateTaskExportConfigurationInput.from(
      { ...this, mapping: Object.fromEntries(this.mapping) },
      CreateTaskExportConfigurationInput,
    );
  }

  forUpdate(): UpdateTaskExportConfigurationInput {
    return UpdateTaskExportConfigurationInput.from(
      { ...this, mapping: Object.fromEntries(this.mapping) },
      UpdateTaskExportConfigurationInput,
    );
  }

  forDelete(): DeleteTaskExportConfigurationInput {
    return DeleteTaskExportConfigurationInput.from(this, DeleteTaskExportConfigurationInput);
  }

  withName(name: string) {
    this.name = name;
    return cloneDeep(this);
  }

  withFilename(filename: string) {
    this.filename = filename;
    return cloneDeep(this);
  }

  withDiscrepancy(discrepancy: boolean) {
    this.discrepancyOnly = discrepancy;
    return cloneDeep(this);
  }

  withCountedOnly(countedOnly: boolean) {
    this.countedOnly = countedOnly;
    return cloneDeep(this);
  }

  withType(type: ExportType) {
    this.type = type;
    return cloneDeep(this);
  }

  withDefault(isDefault: boolean) {
    this.default = isDefault;
    return cloneDeep(this);
  }
}
export class CreateTaskExportConfigurationInput extends forCreate(TaskExportConfiguration) {}

export class UpdateTaskExportConfigurationInput extends forUpdate(TaskExportConfiguration) {}

export class DeleteTaskExportConfigurationInput extends forDelete(TaskExportConfiguration) {}
